var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChangeTextColorNormal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.974,
    height: 18.974,
    viewBox: "0 0 18.974 18.974",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-change-text-color-normal",
    transform: "translate(-143.14 -125.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    transform: "translate(143.14 125.15)",
    fill: "none",
    stroke: "#333",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.487,
    cy: 9.487,
    r: 9.487,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.487,
    cy: 9.487,
    r: 8.987,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M152.627,125.15v18.974a9.487,9.487,0,1,0,0-18.974Z",
    fill: "#333"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChangeTextColorNormal);
export default __webpack_public_path__ + "static/media/icon-change-text-color-normal.28b5f50099951f282e53589c496bb905.svg";
export { ForwardRef as ReactComponent };